import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — restores the viewport to the top of the page on every
 * client-side route change.  Prevents the "new page loads scrolled to the
 * bottom" symptom that occurs because React Router does not reset scroll
 * position by default when navigating between routes.
 *
 * Mounted once, inside <BrowserRouter> in App.js.  Skips scroll reset when
 * the URL includes an in-page hash (e.g. #section) so anchor jumps still
 * work, and skips when the router explicitly opts out via
 * `state.preserveScroll === true`.
 */
export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();
  useEffect(() => {
    if (hash) return;
    if (state && state.preserveScroll) return;
    // `instant` avoids animated jumps during rapid navigation.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, state]);
  return null;
}
